import React, {useEffect} from 'react';
import {useFormikContext} from 'formik';
import {Autocomplete, Card, TextField} from '@mui/material';

const durationUnit = [
  {name: 'Hours', id: 'hours'},
  {name: 'Days', id: 'days'},
  {name: 'Weeks', id: 'weeks'},
  {name: 'Months', id: 'months'},
  {name: 'Years', id: 'years'},
]
export default function LoanEntryThreeUpdate({code}) {
  const {values, setFieldValue} = useFormikContext();

  const getSelectedLoan = (type) => {
    const selected = durationUnit?.find(val => (val?.id === type));
    return selected;
  }

  const selectedLoanUnit = getSelectedLoan(values?.duration_unit);

  useEffect(() => {
    const formatDate = (dateString) => {
      const date = new Date(dateString);
      const year = date.getFullYear();
      let month = date.getMonth() + 1;
      month = month < 10 ? `0${month}` : month;
      let day = date.getDate();
      day = day < 10 ? `0${day}` : day;
      return `${year}-${month}-${day}`;
    };
      const formattedIssueDate = formatDate(values.issue_date);
      const formattedReturnDate = formatDate(values.return_date);
      setFieldValue('issue_date', formattedIssueDate);
      setFieldValue('return_date', formattedReturnDate);

  }, [values.completion_date, values.incoming_date, setFieldValue]);

  return (
    <div>
      <Card className={'box-shadow'} sx={{p: 4, paddingBottom: 5}}>
        <TextField 
          variant={'outlined'} 
          size={'small'} 
          fullWidth 
          label={'Purpose'}
          value={values?.purpose || ''}
          onChange={(e) => setFieldValue('purpose', e.target.value)}
          sx={{mt: 1.5}}
          InputLabelProps={{
            style: {fontSize: 14, color: '#929191'},
            shrink: true
          }}
        />
        <TextField 
          variant={'outlined'} 
          size={'small'} 
          fullWidth 
          label={'Duration'}
          value={values?.duration || ''}
          onChange={(e) => setFieldValue('duration', e.target.value)}
          sx={{mt: 1.5}}
          InputLabelProps={{
            style: {fontSize: 14, color: '#929191'},
            shrink: true
          }}
        />
        <Autocomplete
          key={values?.duration_unit}
          id="combo-box-demo"
          options={durationUnit}
          value={selectedLoanUnit}
          getOptionLabel={(option) => option?.name}
          size={'small'}
          className="dob mr-2 mt-3"
          onChange={(e, value) => {
            setFieldValue('duration_unit', value?.id);
          }}
          isOptionEqualToValue={(option, value) => option?.id === value?.id}
          renderInput={(params) => (
            <TextField 
              {...params}
              placeholder="Duration unit" 
              sx={{mt: 1.5}}
              InputLabelProps={{style: {color: '#000', fontSize: 14}}}
            />
          )}
        />
        <TextField 
          variant={'outlined'} 
          size={'small'} 
          fullWidth 
          label={'Agency Loaned To'}
          value={values?.agency_loaned_to || ''}
          onChange={(e) => setFieldValue('agency_loaned_to', e.target.value)}
          sx={{mt: 1.5}}
          InputLabelProps={{
            style: {fontSize: 14, color: '#929191'},
            shrink: true
          }}
        />
        <TextField 
          variant={'outlined'} 
          size={'small'} 
          fullWidth 
          label={'Issue Date'}
          value={values?.issue_date || ''}
          onChange={(e) => setFieldValue('issue_date', e.target.value)}
          type={'date'}
          sx={{mt: 1.5}}
          InputLabelProps={{
            style: {fontSize: 14, color: '#929191'},
            shrink: true
          }}
        />
        <TextField 
          variant={'outlined'} 
          size={'small'} 
          fullWidth 
          label={'Return Date'}
          value={values?.return_date || ''}
          onChange={(e) => setFieldValue('return_date', e.target.value)}
          type={'date'}
          sx={{mt: 1.5}}
          InputLabelProps={{
            style: {fontSize: 14, color: '#929191'},
            shrink: true
          }}
        />
      </Card>
    </div>
  );
}